(async () => {

  if (!customElements.get('product-video')) {

    const { Fancybox } = await import("@fancyapps/ui");

    class ProductVideo extends HTMLElement {
      constructor() {
        super();

        this.fancybox();
      }

      /*
      * Create fancybox
      */
      fancybox() {
        Fancybox.bind("[data-fancybox]", {
          animated: false,
          showClass: false
        });
      }
    }

    window.ProductVideo = ProductVideo;

    customElements.define('product-video', ProductVideo);

  }

})();
